import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'mouth-off',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M13.074 7.417a2.6 2.6 0 012.989.099c1.829 1.36 3.053 2.076 5.479 3.644a1 1 0 01.308 1.368 11.6 11.6 0 01-1.617 2.05',
        key: '150453',
      },
    ],
    ['path', { d: 'M2 12a50.5 50.5 0 0010.99.99', key: '1ccgm2' }],
    ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
    ['path', { d: 'M21 11a1 1 0 011 1 51 51 0 01-3.734.61', key: '5gbt18' }],
    [
      'path',
      {
        d: 'M7.695 7.695c-1.7 1.247-2.92 1.967-5.238 3.464a1 1 0 00-.307 1.369 11.6 11.6 0 0014.766 4.388',
        key: '4jj8yu',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name MouthOff
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuMDc0IDcuNDE3YTIuNiAyLjYgMCAwMTIuOTg5LjA5OWMxLjgyOSAxLjM2IDMuMDUzIDIuMDc2IDUuNDc5IDMuNjQ0YTEgMSAwIDAxLjMwOCAxLjM2OCAxMS42IDExLjYgMCAwMS0xLjYxNyAyLjA1IiAvPgogIDxwYXRoIGQ9Ik0yIDEyYTUwLjUgNTAuNSAwIDAwMTAuOTkuOTkiIC8+CiAgPHBhdGggZD0ibTIgMiAyMCAyMCIgLz4KICA8cGF0aCBkPSJNMjEgMTFhMSAxIDAgMDExIDEgNTEgNTEgMCAwMS0zLjczNC42MSIgLz4KICA8cGF0aCBkPSJNNy42OTUgNy42OTVjLTEuNyAxLjI0Ny0yLjkyIDEuOTY3LTUuMjM4IDMuNDY0YTEgMSAwIDAwLS4zMDcgMS4zNjkgMTEuNiAxMS42IDAgMDAxNC43NjYgNC4zODgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mouth-off
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MouthOff = createLucideIcon(__iconData);

export default MouthOff;
